import { AssetSource, JobStatus } from '../../../enums';
import { Item, Schema } from '../../../models';
import { FuelUserAccess } from '../../../models/FuelUserAccess';
import { OU } from '../../../models/Ou';
import { SchemaType } from '../../forms/Asset-Editor/SchemaTypeOptions';

export const createAssetSkeleton: (schemaType: SchemaType, fuelUserAccessData: FuelUserAccess, ouData: OU) => Item = (
  schemaType,
  fuelUserAccessData,
  ouData
) => {
  // console.log('createAssetSkeleton', schemaType);
  const obj: Item = {
    //id: uuid(), // this is being left out now because of a recent change where the backend will now assign the asset id...
    ouId: ouData.ouId,
    ouName: ouData.ouName,
    schemaType: schemaType,
    applyAutomatedTransitions: null,
    clipVersion: 'v2',
    data: {
      originalFileName: null,
      businessMetadata: {
        embargoDateOverride: null,
        embargoDate: null,
        expireDateOverride: null,
        expireDate: null,
        title: null,
        automatedTitle: null,
        synopsis: null,
        breakingnewsDate: null,
        relevantnowDate: null,
        publicationDate: null,
      },
      technicalMetadata: null,
      videoProxy: null,
      thumbnail: null,
      ingestStatus: JobStatus.Unknown,
    },
    fileUri: null,
    previewUri: null,
    categories: [],
    zipcode: null,
    tags: [],
    attributes: [],
    priority: 0,
    conformStatus: null,
    // streamingEngineClipId: null,
    source: AssetSource.Ingest,
    parentId: null,
    createdBy: fuelUserAccessData.userId,
    sourceFileUrl: null,
    entityType: 'Clip',
  };
  return obj;
};
